import React, { useEffect } from "react";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const APP_STORE_URL = "https://apps.apple.com/ci/app/goallfit/id6755972326";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=com.lsd.goalfit";

export default function DownloadPage() {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = APP_STORE_URL;
    }

    if (/android/i.test(navigator.userAgent)) {
      window.location.href = PLAY_STORE_URL;
    }
  }, []);

  const isAndroid = /android/i.test(navigator.userAgent);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Télécharger GoalFit</h1>
        <p style={styles.subtitle}>
          Transformez vos objectifs fitness en résultats concrets 💪
        </p>

        {!isAndroid && (
          <div style={styles.buttons}>
            <a href={APP_STORE_URL} style={styles.storeBtn}>
              <FaApple size={28} />
              <div>
                <span style={styles.small}>Télécharger sur</span>
                <span style={styles.big}>App Store</span>
              </div>
            </a>

            <a href={PLAY_STORE_URL} style={styles.storeBtn}>
              <FaGooglePlay size={26} />
              <div>
                <span style={styles.small}>Télécharger sur</span>
                <span style={styles.big}>Google Play</span>
              </div>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

/* ---------------- STYLES ---------------- */

const styles = {
  page: {
    minHeight: "100vh",
    background: "radial-gradient(circle at top, #0b1a3a, #050b1e)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
    color: "#fff",
    fontFamily: "Poppins, sans-serif",
  },

  card: {
    maxWidth: 420,
    width: "100%",
    background: "rgba(255,255,255,0.05)",
    backdropFilter: "blur(16px)",
    borderRadius: 24,
    padding: 30,
    textAlign: "center",
    boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
  },

  title: {
    fontSize: 28,
    fontWeight: 900,
    marginBottom: 10,
  },

  subtitle: {
    opacity: 0.8,
    marginBottom: 30,
  },

  buttons: {
    display: "flex",
    flexDirection: "column",
    gap: 14,
  },

  storeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 14,
    background: "#111",
    padding: "14px 20px",
    borderRadius: 16,
    textDecoration: "none",
    color: "#fff",
    fontWeight: 700,
    transition: "0.25s",
  },

  small: {
    fontSize: 12,
    opacity: 0.7,
  },

  big: {
    fontSize: 18,
    fontWeight: 800,
  },
};
